/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Adding_Team_CreatingInputs */



/**
* | output |
* | --- |
* | "Adding..." |
*
* @param {Spaces_Adding_Team_CreatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_adding_team_creating = /** @type {((inputs?: Spaces_Adding_Team_CreatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Adding_Team_CreatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge hinzu...")
	return /** @type {LocalizedString} */ ("Adding...")
});